module.exports = __webpack_public_path__ + "assets/fonts/GothamPro-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/gothampro/GothamPro-Light.ttf
// module id = 1900
// module chunks = 0